import React from 'react';

import { Button } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { GoogleTagManagerService } from 'gtm';
import { GoogleIcon } from 'icons/GoogleIcon';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { AuthService } from 'services/auth-service';

const TEN_SECONDS = 10000;

interface GoogleAuthButtonProps {
  disabled?: boolean;
  loading?: boolean;
  trigger?: boolean;
  fromRegister?: boolean;
}

export function GoogleAuthButton({
  disabled = false,
  loading = false,
  trigger = false,
  fromRegister = false
}: GoogleAuthButtonProps) {
  const { t } = useTranslation();
  const queryParams = queryString.parse(location.search);

  const googleAuthUrlMutation = useMutation({
    mutationFn: AuthService.getGoogleAuthUrl,
    onSuccess: async (url: string) => {
      // Fire signup event in GTM if the user is coming from the register page
      if (fromRegister) GoogleTagManagerService.sendSignupEvent();

      window.location.href = url;

      // Wait 10 seconds so that the loader can still be seen while redirecting
      await new Promise((resolve) => setTimeout(resolve, TEN_SECONDS));
    }
  });

  if (trigger) googleAuthUrlMutation.mutate(queryParams);

  return (
    <Button
      variant="outline"
      fullWidth
      disabled={disabled}
      loading={googleAuthUrlMutation.isLoading || loading}
      onClick={() => googleAuthUrlMutation.mutate(queryParams)}
      leftIcon={<GoogleIcon />}>
      {t('AUTH.GOOGLE.CONTINUE')}
    </Button>
  );
}
